import * as S from './styles';
import { Props } from './types';
import { Button } from '@getinapp/appetizer';

export const GiveUpModal = ({
  isModalVisible,
  setIsModalVisible,
  onCancelLine,
  loading,
}: Props) => {
  const handleCloseModal = () => setIsModalVisible(false);

  return (
    <S.Modal
      width="15%"
      title="Atenção"
      isOpen={isModalVisible}
      onRequestClose={handleCloseModal}
    >
      <p>
        Tem certeza que deseja desistir? Você perderá o seu lugar na fila de
        espera.
      </p>
      <S.WrapperButtons>
        <Button variant="outline" loading={loading} onClick={onCancelLine}>
          Desistir da fila
        </Button>
        <Button className="come-back" onClick={handleCloseModal}>
          Voltar
        </Button>
      </S.WrapperButtons>
    </S.Modal>
  );
};
